<script setup lang="ts">
import type { FormDefinitionBase } from '@hubspot/api-client/lib/codegen/marketing/forms'

defineProps<{
  data: FormDefinitionBase['legalConsentOptions']
}>()
</script>

<template>
  <div>
    <div
      v-if="data.communicationConsentText"
      v-html="data.communicationConsentText"
    />

    <FormCheckbox
      v-for="field in data.communicationsCheckboxes"
      :id="field.subscriptionTypeId"
      :key="field.subscriptionTypeId"
      :required="field.required"
      :name="subscriptionTypeUtils.createFieldName(field.subscriptionTypeId)"
    >
      <template #label>
        <div v-html="field.label" />
      </template>
    </FormCheckbox>

    <div
      v-if="data.privacyText"
      v-html="data.privacyText"
    />

    <div
      v-if="data.consentToProcessText"
      v-html="data.consentToProcessText"
    />

    <div
      v-if="data.consentToProcessFooterText"
      v-html="data.consentToProcessFooterText"
    />
  </div>
</template>
